import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { getApiClient, initializeApiClient } from "../../../../Services/Api/ApiServices";
// import {
//   getApiClient,
//   initializeApiClient,
// } from "../../../Services/apiService";

export const GetRoleByUserGuid = createAsyncThunk(
  "GetRoleByUserGuid",
  async (uS_UserGuid, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post("api/Account/GetRoleByUserGuid", {
        uS_UserGuid: uS_UserGuid,
      });

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "GetRoleByUserGuid");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);

export const HandelRolePageFunction = createAsyncThunk(
  "HandelRolePage",
  async (uS_UserGuid, { rejectWithValue }) => {
    try {
      await initializeApiClient();
      const apiClient = await getApiClient();
      const response = await apiClient.post("api/Authentication/HandelRolePage", uS_UserGuid);

      // Extract data from the response object
      const data = response.data.result; // Assuming response has a "data" field
      //console.log(data, "GetRoleByUserGuid");

      return data; // Return the extracted data
    } catch (error) {
      return rejectWithValue(error.message);
    }
  }
);


const RoleByUserGuid = createSlice({
  name: "RoleByUserGuid",
  initialState: {
    RoleByUserGuid: [],
    loadingRoleByUserGuid: false,
    errorRoleByUserGuid: null,
    //////////////////////////////////
    HandelRolePage: [],
    loadingHandelRolePage: false,
    errorHandelRolePage: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(GetRoleByUserGuid.pending, (state, action) => {
        state.loadingRoleByUserGuid = true;
        state.RoleByUserGuid = action.payload;
        state.errorRoleByUserGuid = null;
      })
      .addCase(GetRoleByUserGuid.fulfilled, (state, action) => {
        state.loadingRoleByUserGuid = false;
        state.RoleByUserGuid = action.payload; // Assuming payload has the desired data
      })
      .addCase(GetRoleByUserGuid.rejected, (state, action) => {
        state.loadingRoleByUserGuid = false;
        state.RoleByUserGuid = action.payload;
      });
      ///////////////////////////////////////
      builder
      .addCase(HandelRolePageFunction.pending, (state, action) => {
        state.loadingHandelRolePage = true;
        state.HandelRolePage = action.payload;
        state.errorHandelRolePage = null;
      })
      .addCase(HandelRolePageFunction.fulfilled, (state, action) => {
        state.loadingHandelRolePage = false;
        state.HandelRolePage = action.payload; // Assuming payload has the desired data
      })
      .addCase(HandelRolePageFunction.rejected, (state, action) => {
        state.loadingHandelRolePage = false;
        state.HandelRolePage = action.payload;
      });
  },
});

export default RoleByUserGuid.reducer;
